import React from 'react';
import PropTypes from 'prop-types';
import _classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      padding: '0 18px !important',
    },
  },
}));

function PaddedGrid(props) {
  const classes = useStyles();
  const { children, className, ...rest } = props;
  return (
    <Grid
      item
      xs={12}
      className={_classNames(classes.root, className)}
      {...rest}
    >
      {children}
    </Grid>
  );
}

PaddedGrid.propTypes = {
  children: PropTypes.node,
};

export default PaddedGrid;
